import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ifnqhafstcwbcnjwoqgj.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlmbnFoYWZzdGN3YmNuandvcWdqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODE4MDA4NDUsImV4cCI6MjA5NzM3Njg0NX0.E_iigJnY7vUALRsvyd_6xBK0tZfu0eOhJbbftdsMW20';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
